module.exports = __webpack_public_path__ + "media/charte_selection/arrow2-ccea6324.png";